<template>
    <div class="m-stepper-object-create container">
        <div class="content-border-area">
            <m-form-object-types @form:submit="valTypes" ref="formTypes"/>
            <m-form-object :objectTypeId="objectTypeId" @form:submit="valObject" ref="formObject"/>
            <m-form-object-trades @form:cancel="cancelForm" @form:submit="finalSubmit" ref="formTrades"/>
        </div>
        <v-layout class="m-stepper-object-create__btn mt-3" justify-end>
            <e-button-primary @click="submit">{{$t('modules.forms.m-form-object.buttons.submit')}}</e-button-primary>
        </v-layout>
    </div>
</template>

<script>
    import mFormObject from "@modules/forms/concrete/objects/m-form-object";
    import MFormObjectTrades from "@modules/forms/concrete/objects/m-form-object-trades";
    import MFormObjectTypes from "@modules/forms/concrete/objects/m-form-object-types";

    import {mapActions} from 'vuex';
    import isEmpty from 'lodash/isEmpty';
    import pick from 'lodash/pick'
    import baseStepper from "@mixins/components/modules/steppers/base";

    let name = 'm-stepper-object-create';

    export default {
        name: name,
        mixins: [
            baseStepper
        ],
        components: {
            MFormObjectTypes,
            MFormObjectTrades,
            mFormObject
        },
        props: {
            name: {
                type: String,
                default: name
            },
            isOnboarding: {
                type: Boolean,
                default: false
            },
        },
        data: function () {
            return {
                steps: [
                    {
                        title: this.$t('modules.steppers.m-stepper-object-create.step-1.title')
                    }, {
                        title: this.$t('modules.steppers.m-stepper-object-create.step-2.title')
                    }, {
                        title: this.$t('modules.steppers.m-stepper-object-create.step-3.title')
                    }
                ],
                objectTypeId: '',
                form: {},
                valSteps: {
                    types: false,
                    object: false,
                    trades: false
                }
            }
        },
        methods: {
            ...mapActions({
                createObject: 'objects/create'
            }),

            next(data) {
                if (data && data.objectTypeId) {
                    this.objectTypeId = data.objectTypeId
                } else if (data) {
                    Object.assign(this.form, data);
                }

                //this.$refs.stepper.nextStep()
            },

            valTypes(data) {
                if (data && data.objectTypeId) {
                    this.objectTypeId = data.objectTypeId
                    this.valSteps.types = true;
                }
            },
            valObject(data) {
                if (data) {
                    Object.assign(this.form, data);
                    this.valSteps.object = true;
                }
            },

            async submit(formData) {
                this.$emit('confirm', false);
                await this.$refs.formTypes.submit();
                await this.$refs.formObject.submit()
                setTimeout(() => {
                    if(this.valSteps.types && this.valSteps.object) {
                        this.$refs.formTrades.submit()
                    }
                }, 10)
            },

            async finalSubmit(formData){
                let payload = this.addExtraData(Object.assign(this.form), formData);
                try {
                    let object = await this.createObject(payload);
                    this.notify.success(this.$t('notifications.objects.created', {name: object.name}));
                    this.$router.push({
                        name: this.nav.dashboard.service.objects.index.name,
                        params: {
                            createdObject: true
                        }
                    })
                } catch (e) {
                    this.notify.processUnhandledError(e)
                }
            },

            addExtraData(data, formData) {
                let extraData = {
                    _jv: {
                        type: this.keys.objects.key,
                        relationships: {
                            // TODO: remove mutation of data which we got from server.
                            objectType: {
                                data: {type: this.keys.objectTypes.key, id: this.objectTypeId}
                            },
                            owner: {
                                data: {type: this.keys.users.key, id: this.$user.id}
                            }
                        }
                    }
                };

                if (!isEmpty(formData.businessTypes)) {
                    let data = formData.businessTypes.map((i) => pick(i._jv, ['id', 'type']));

                    extraData._jv.relationships.businessType = {
                        data
                    };
                }

                if (!isEmpty(formData.moderators)) {
                    let data = formData.moderators.map((i) => pick(i._jv, ['id', 'type']));

                    extraData._jv.relationships.moderators = {
                        data
                    };
                }

                return Object.assign(data, extraData);
            },

            cancelForm() {
                this.$refs.stepper.prevStep()
            },
            cancel() {
                this.goBack()
            }
        }
    }
</script>

<style scoped lang="scss">
    .object-stepper {
        &__type-item {
            max-width: 300px;
        }
    }
    .m-stepper-object-create {
        &__container {
            padding: 2rem;
        }
    }

    .m-stepper-object-object-type-title {

    }

    .m-stepper-object-object-type-divider {

    }

</style>

<style lang="scss">
    .app-layout__auth {
        .m-stepper-object-create {
            padding-top: 1rem;

            .content-border-area {
                padding-top: 0;
            }
            .m-stepper__header-container {
                display: none;
            }
            .m-block-form-buttons {
                display: none;
            }

            &__btn {
                button {
                    @include media(md) {
                        margin: 0;
                    }
                }
            }
        }
    }

</style>
